/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2014-2016, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
'use strict';

angular.module('bulbApp.contentEditorModule')

.directive('bulbFrame', bulbFrame);

function bulbFrame() {
  return {
    restrict: 'E',
    require: '^contentBlock',
    transclude: true,
    priority: 999,
    templateUrl: 'ajs/components/contenteditor/frame.html',
    controller: 'FrameController as frameCtrl',
    compile: function () {
      return {
        pre: function(scope, elem, attrs, contentBlockCtrl) {
          elem.addClass('bulb-asset-container');
          elem.addClass('bulb-content-frame');
          elem.attr('selectable-block', '');

          /**
           * This needs to be run in the pre-compile so that the frame element is available
           * in the other directive's linking functions.
           */
          // TODO CLEAN : should this be added to the contentBlockCtrl, or put it in the frameCtrl?
          contentBlockCtrl.frameElement = elem;
        }
      };
    }
  };
}
